import { HTTP_VERBS } from "../../enums";
import { CombinedFormDO } from "../domainObjects";

export const httpVerb = HTTP_VERBS.POST;
export const url = "/api/users/combinedForm";
export class Response extends CombinedFormDO {}
